export default "__VITE_ASSET__BDTsFewy__"